import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Disease, PetDetail, Vaccine } from '../../interfaces/pet';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { ModalService } from '@coreui/angular';
import { OwnerDetail } from 'src/app/interfaces/owner';
import { PetService } from 'src/app/services/pet.service';
import { Subject } from 'rxjs';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';

// import { KycService } from 'src/app/services/kyc/kyc-service';
// import { WinNotificationService } from 'src/app/services/win-notification.service';

@Component({
  selector: 'app-success-dialog',
  templateUrl: './success-dialog.component.html',
  styleUrls: ['./success-dialog.component.scss']
})
export class SuccessDialogComponent implements OnInit {
  @Input() message: string = '';
  @Input() title: string = '';

  public onClose= new Subject<boolean>();
  modalRef: BsModalRef;

  constructor(
    private modalService: ModalService,
    public bsModalRef: BsModalRef,) {
      this.modalRef = bsModalRef;
  }

  ngOnInit(): void {

  } // end of ngOnInit

  hideModal(result: boolean) {
    this.onClose.next(true);
    this.bsModalRef.hide();
  } // end of hideModal

  closeModal() {
    this.hideModal(false);
  } // end of hideModal

  // closeModal() {
  //   this.modalService.clos();
  // }

}
